// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1I_Rk","name":"Header_name__QKkSI","birthday":"Header_birthday__eI-BA","skeleton":"Header_skeleton__1z-Jh"};